/** The pocket's root (spec §7.3 Search): search every thing Denker remembers, or walk the suggestions waiting for review. A result
 * becomes the focus as a jump from You (mockup pickThing). */
import { useState } from "react";
import type { MemoryThing } from "@/api/memory-focus";
import { PocketRow, PocketSection } from "@/components/ui";
import { useT } from "@/i18n";
import { framesMemoryMessages } from "@/i18n/messages/frames-memory";
import { thingDisplayName } from "@/lib/memory-thing-kinds";
import { useMemoryStore } from "@/stores/memory-store";
import { MemorySearchField } from "./memory-search-field";
import { MemorySearchResults } from "./memory-search-results";
export function PocketSearchLevel({ youName }: { youName: string }) {
  const t = useT(framesMemoryMessages);
  const [query, setQuery] = useState("");
  const remembers = useMemoryStore((s) => s.globe?.memory_size ?? null);
  const reviewCount = useMemoryStore((s) => s.reviewItems.length);
  const q = query.trim();
  const focus = (thing: MemoryThing) => {
    if (thing.id)
      useMemoryStore
        .getState()
        .openThing(thing.id, thingDisplayName(thing), "jump");
  };
  return (
    <div data-testid="memory-search-level">
      <MemorySearchField
        value={query}
        onChange={setQuery}
        placeholder={
          remembers
            ? t("searchThings", { count: remembers })
            : t("searchMemory")
        }
        testId="memory-search-input"
        autoFocus
      />
      {!q && reviewCount > 0 ? (
        <PocketSection>
          <PocketRow
            testId="memory-search-review"
            title={t("suggestionsToReview", { count: reviewCount })}
            status={{ tone: "question" }}
            chevron
            onSelect={() => useMemoryStore.getState().openReview()}
          />
        </PocketSection>
      ) : null}
      <MemorySearchResults
        query={q}
        youName={youName}
        emptyText={t("searchNothingCalled", { query: q })}
        onOpen={focus}
      />
    </div>
  );
}
